import React from 'react';
import { FormField, FormFieldProps } from '../components/form/FormField';
import CommentableField from '../components/common/CommentableField';
import { Comment } from '../lib/types/CommentTypes';
import { useIntakeFormStore } from '../stores/intakeFormStore';

export interface FormSectionProps {
  comments?: Comment[];
  clientId?: string;
  author?: 'client' | 'hailey';
  token?: string;
  password?: string;
  onCommentSubmit?: () => void;
  isEditMode?: boolean;
}

interface FormSectionReturn {
  Field: React.FC<FormFieldProps>;
  formData: any;
  updateField: (path: string, value: any) => void;
}

export const useFormSection = (props: FormSectionProps): FormSectionReturn => {
  const { comments, clientId, author, token, password, onCommentSubmit } = props;
  const formData = useIntakeFormStore(state => state.formData);
  const updateField = useIntakeFormStore(state => state.updateField);
  
  // Create a wrapped FormField component that includes CommentableField functionality
  const Field: React.FC<FormFieldProps> = React.useCallback((fieldProps: FormFieldProps) => {
    const fieldComponent = <FormField {...fieldProps} />;
    
    // If comments are enabled, wrap with CommentableField
    if (comments && clientId && author && onCommentSubmit) {
      return (
        <CommentableField
          fieldId={fieldProps.path}
          clientId={clientId}
          author={author}
          token={token}
          password={password}
          comments={comments}
          onCommentSubmit={onCommentSubmit}
        >
          {fieldComponent}
        </CommentableField>
      );
    }
    
    return fieldComponent;
  }, [comments, clientId, author, token, password, onCommentSubmit]);
  
  return {
    Field,
    formData,
    updateField
  };
};